<mat-form-field>
    <input
        matInput
        [matAutocomplete]="autoStoragePlace"
        [formControl]="storagePlaceFormCtrl"
        placeholder="Lagerplatz"
    />
    <mat-autocomplete
        #autoStoragePlace="matAutocomplete"
        [displayWith]="storagePlaceMapper"
        (optionSelected)="autocompleteStoragePlaceSelected($event)"
    >
        <mat-option *ngFor="let sp of storagePlaces | async" [value]="sp">
            <span>{{ sp.bezeichnung }}</span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
